app.controller('CIFBenef-CTRL', ['$scope','$rootScope','$http', '$window', '$q', '$filter', 'appFactory',
    function ($scope,$rootScope,$http, $window, $q, $filter, appFactory) {

    $scope.PhoneCode = '+62';
    $scope.CIFInvestor = {}
    $scope.bankpribadi = '';

    let tmpdate = new Date();
    tmpdate.setFullYear(tmpdate.getFullYear() - 17);
    $scope.maxDate = tmpdate.toISOString().slice(0, 10);

   
    $scope.IDCardCitySelectedBO = '';

    $scope.chkSeumurHidupBO = true;
    $scope.DisabledSeumurHidupBO = true;
    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiryDate = new Date(9998, 11, 31);

    $scope.selectedFundSourceBO = [];
    $scope.BenefCountrySelected = [];

    $scope.CIFInvestor = {
        CIFInvestorBeneficiaryOwnerOccupation: ''
    }

    $scope.listpekerjaan_BCA = {};
    $scope.listjabatan_BCA = {};
    $scope.listusaha_BCA = {};

    $scope.OPBBCABO = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.mustSelectBO = function (event, field) {

        if (event.keyCode == 27) {

            let returnValue = true;
            switch (field) {
                case 'IDCardBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = ''; returnValue = false;
                    break;
                case 'CompanyBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }

    $scope.selectIDCardCityBO = function (item, model, label, event) {
        $scope.ListKecamatanBO = '';
        $scope.ListKelurahanBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanBO = data.data.d;
                $scope.kecamatanChangeBO();
            }, function (error) { });

        }

    };


    $scope.kecamatanChangeBO = function () {

        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan)
            $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
    }

    $scope.kelurahanChangeBO = function () {

        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan) {

            let temp = $filter('filter')($scope.ListKecamatanBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan }, true);
            if (temp)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPostalCode = temp[0].PostalCode;

        }
    }


    $scope.selectIDCardCityBenefOther = function (item, model, label, event) {
        $scope.ListKecamatanDomicileBO = '';
        $scope.ListKelurahanDomicileBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOtherCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanDomicileBO = data.data.d;
                $scope.kecamatanDomicileBenefChange();
            }, function (error) { });

        }

    };

    $scope.selectCompanyCityBO = function (item, model, label, event) {
        $scope.ListKecamatanCompanyBO = '';
        $scope.ListKelurahanCompanyBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = item.CIFProvinceCityNID;
            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanCompanyBO = data.data.d;
                $scope.kecamatanChangeCompanyCityBO();
            }, function (error) { });
        }

    };

    $scope.selectNationalityBO = function (item, model, label, event) {
        if (item.CIFCountryNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCountry = item.CIFCountryNID;
            $scope.BenefCountrySelected = item;
        }

    };


    $scope.toggleFundSourceBOItem = function (fundsource) {
        let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSourceBO.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSourceBO.indexOf(1) < 0)
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSourceText = '';

    }

    $scope.occupationChange_BCA = function () {

        if ($scope.OPBBCABO.occupation) {

            $http({
                method: 'GET',
                url: 'service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCABO.occupation.key,
            }).then(function (data) {


                $scope.listjabatan_BCA = data.data.d;

                if ($scope.listjabatan_BCA.length) {
                    $scope.OPBBCABO.position = $scope.listjabatan_BCA[0];

                    $scope.positionChange_BCA();
                }
            }, function (error) { });
        }
    };

    $scope.positionChange_BCA = function () {
        $http({
            method: 'GET',
            url: 'service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCABO.position.key + '&Pekerjaan=' + $scope.OPBBCABO.occupation.key,
        }).then(function (data) {

            $scope.listusaha_BCA = data.data.d;

            if ($scope.listusaha_BCA.length) {

                $scope.OPBBCABO.businessText = '';
                $scope.OPBBCABO.business = $scope.listusaha_BCA[0];
            }
        }, function (error) { });
    };

    $scope.prepareData = function () {

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = $scope.OPBBCABO.occupation.key;

            if ($scope.OPBBCABO.occupation.key == '2' || $scope.OPBBCABO.occupation.key == '3' || $scope.OPBBCABO.occupation.key == '18') {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition = $scope.OPBBCABO.positionText;
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness = $scope.OPBBCABO.businessText;
            }
            else {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition = $scope.OPBBCABO.position.value;
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness = $scope.OPBBCABO.business.value;
            }
        }

        if ($scope.spouseMandatory) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 2;
            //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
        } else {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 1;
        }


        if ($scope.selectedFundSourceBO) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = '';
            for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.length > 0)
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += ',';
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += $scope.selectedFundSourceBO[i];

            }
        }
    };


  
    var allPromise = $q.all([


          appFactory.getData(`service/client.svc/GetCIFCountry`).then(function (data) {

              if (data.status == 200) {

                  $scope.ListNationality = data.data.d;
              }
          }),

           appFactory.getData(`service/client.svc/GetCIFCountryAll`).then(function (data) {

               if (data.status == 200) {

                   $scope.ListCountry = data.data.d;
               }
           }),


        appFactory.getData(`service/client.svc/GetCIFProvinceCity`).then(function (data) {

            if (data.status == 200) {

                $scope.ListProvinceCity = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetCIFLookup`).then(function (data) {

            if (data.status == 200) {

                $scope.ListLookup = data.data.d;

                if ($scope.ListLookup) {
                    $scope.ListMaritalBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                    $scope.ListEducationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                    $scope.ListAssetsValue = $filter('filter')($scope.ListLookup, { CIFLookupID: 'NetWorth' }, true);
                    $scope.ListOccupationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListFundSourceBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListInvestmentBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
                    $scope.ListIncomePerAnnumBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                }
            }
        }),

         appFactory.getData(`service/client.svc/GetCIFPekerjaan`).then(function (data) {

              if (data.status == 200) {

                  $scope.listpekerjaan_BCA = data.data.d;
              }
          }),

        appFactory.getData(`service/client.svc/GetJabatan`).then(function (data) {

            if (data.status == 200) {

                $scope.listposition_BCA = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetBidangUsaha`).then(function (data) {

            if (data.status == 200) {

                $scope.listnature_BCA = data.data.d;
            }
        })

    ]);

    allPromise.then(function () {

        appFactory.getData(`service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 2;

                    if ($scope.CIFInvestor.QuestionRDN == 1) {

                        if ($scope.CIFInvestor.Occupation == 1 || $scope.CIFInvestor.Occupation == 2) {
                            $scope.spouseMandatory = true;
                        }

                        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation && $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation > 0) {

                            $scope.OPBBCABO.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation }, true)[0];


                            $http({
                                method: 'GET',
                                url: 'service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCABO.occupation.key,
                            }).then(function (data) {

                                $scope.listjabatan_BCA = data.data.d;


                            }, function (error) { });
                            console.log('hhhh', $scope.OPBBCABO.occupation.key);

                            if ($scope.OPBBCABO.occupation.key == 2 || $scope.OPBBCABO.occupation.key == 3 || $scope.OPBBCABO.occupation.key == 18) {
                                console.log('hh');
                                $scope.OPBBCABO.positionText = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition;
                                $scope.OPBBCABO.businessText = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness;

                            }
                        }
                    }
                    
                    $scope.BenefCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCountry) }, true)[0];

                    if (data.data.d.CIFInvestorBeneficiaryOwnerCity) {

                        $scope.IDCardCitySelectedBO = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCity }, true)[0];

                        appFactory.getData(`service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${data.data.d.CIFInvestorBeneficiaryOwnerCity}`).then(function (data) {

                            if (data.status == 200) {

                                $scope.ListKecamatanBO = data.data.d;
                                if ($scope.ListKecamatanBO)
                                    $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
                            }
                        })
                    }


                    console.log('IDCardCitySelectedBO ', $scope.IDCardCitySelectedBO)


                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity)
                        $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity }, true)[0];

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource) {

                        $scope.selectedFundSourceBO = [];
                        let temp = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSourceBO.push(Number(temp[i]));
                        }
                    }


                    if (data.data.d.CIFInvestorBeneficiaryOwnerBirthDate)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerBirthDate = new Date(data.data.d.CIFInvestorBeneficiaryOwnerBirthDate);


                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation == 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = '';
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution == 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution = '';

                } 
            }
        })
    });

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: 'service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {

                    if (data.data.d.result) {
                        Swal.close();
                        $window.location.href = "#/cif/data-pendukung";
                    }
                    else {
                        Swal.fire('Failed', data.data.d.response, 'error');
                    }
                }, function (error) {
                    Swal.fire('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }
}]);